import { useEffect } from "react";
import {batch, useSignal} from "@preact/signals-react";
import {postSubmit} from "@ui-seeker/utils";

import {isLoadingCommonFilters, commonFiltersValue, isSystemBusy} from "@signals";
import {WEBBACK_V2_API} from "@constants";
import {productPageImageDetailsIsEmpty} from "../@signals";


export default function useProductPageImageDetailsFilters() {

    const data = useSignal([])

    useEffect(() => {
        if (isLoadingCommonFilters.value) batch(() => {
            // Served by dipi-webback-v2: the published gallery resolved against the customer's
            // catalogue, verified against v1 image by image (7.818 of them). There is no
            // MARKETPLACES variant of this screen, so the URL is direct and not role-based.
            postSubmit(`${WEBBACK_V2_API}/product-page/image-details/context`, commonFiltersValue.value).then(res => batch(() => {
                if(!res.length)
                    productPageImageDetailsIsEmpty.value = true
                data.value = res
            }))
            .catch(() => isSystemBusy.value = true)
            .finally(() => { isLoadingCommonFilters.value = false})
        })
    }, [isLoadingCommonFilters.value])

    return {
        data: data.value
    }
}